<template>
  <div class="substep-connect-payroll">
    <div class="substep-header">
      <h3 data-testId="step-title">Connect payroll</h3>
      <p>Connect your Wise account to easily manage team payments.</p>
    </div>
    <div class="substep-body">
      <template v-if="integrationCompleted">
        <div class="card-image">
          <img :src="images.integration_completed" />
          <h4>
            Congrats! You explored your first payroll integration. To revisit our integrations
            <a href="/integrations">click here.</a>
          </h4>
        </div>
      </template>
      <template v-else>
        <div class="integration-thumb-preferred transferwise with-logo">
          <div class="preferred-integration-body">
            <div class="preferred-integration-logo">
              <img
                :src="images.wise_logo"
                alt="Wise Integration"
              />
            </div>
            <div class="preferred-integration-text">
              <h5 class="pi-title">Pay your team with Wise</h5>
              <div class="pi-text">
                Pay your team automatically at the end of each pay period.
                <br />
                Just connect your Wise account and start paying your team.
              </div>
            </div>
            <ul class="prefered-integration-features features-transferwise">
              <li>Set up in a snap</li>
              <li>Instant payments</li>
              <li>Lowest international fees</li>
            </ul>
            <div class="preferred-integration-actions">
              <a
                id="primary-cta-promotion-banner"
                class="btn btn-sm btn-primary"
                :href="integrations.wise.connect_url"
                rel="noopener noreferrer"
                target="_blank"
                data-feature="payroll"
                data-promotion_type="preferred_banner"
                data-product="transferwise"
                @click="connectWise"
              >
                Connect to Wise
              </a>
              <a
                :href="integrations.wise.sign_up_url"
                rel="noopener noreferrer"
                class="btn btn-sm btn-transparent-outline"
                target="_blank"
              >
                Create a Wise account
              </a>
            </div>
          </div>
          <div class="preferred-integration-head">
            <img
              :src="images.wise_banner"
              class="img-transferwise"
              alt="Wise Integration"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import { GETTING_STARTED } from '~/app_constants';

export default {
  name: 'ConnectPayroll',
  mixins: [GettingStartedMixin],
  props: {
    integrations: {
      type: Object,
      required: true,
      validator(value) {
        return value.wise !== undefined;
      },
    },
  },
  data: () => ({
    integrationCompleted: false,
    images: GETTING_STARTED,
  }),
  beforeMount() {
    if (this.integrations.wise.enabled) {
      this.integrationCompleted = true;
    }
    this.$emit('completeSubstep');
  },
  methods: {
    connectWise() {
      this.integrationCompleted = true;
    },
  },
};
</script>
